/* Buton fix „Caută pe site”: panou cu rezultate din Predictive Search API
   (https://shopify.dev/docs/api/ajax/reference/predictive-search).
   Markup-ul e în snippets/cauta-pe-site.liquid. */
(function () {
  var R = document.getElementById('cauta');
  if (!R || R.hasAttribute('data-cauta-gata')) return;
  R.setAttribute('data-cauta-gata', '');

  var B = R.querySelector('.cauta-buton'),
    P = R.querySelector('.cauta-panou'),
    F = R.querySelector('form'),
    I = F.querySelector('input'),
    O = R.querySelector('.cauta-rez');
  var URL_SUGESTII = R.getAttribute('data-cauta-sugestii'),
    URL_TOATE = R.getAttribute('data-cauta-toate'),
    URL_BLOG = R.getAttribute('data-cauta-blog');
  var MAX = 5, MIN = 3, ASTEAPTA = 250;
  var FEL = { products: 'Produs', pages: 'Pagină', articles: 'Articol' };
  var temporizator = null, cerere = null, ultima = '';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function text(html) {
    var d = new DOMParser().parseFromString(html || '', 'text/html');
    return (d.body.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function scurt(s) {
    if (s.length <= 140) return s;
    var t = s.slice(0, 140), sp = t.lastIndexOf(' ');
    return (sp > 100 ? t.slice(0, sp) : t).replace(/[\s,.;:]+$/, '') + '…';
  }

  function deschide(d) {
    R.classList.toggle('e-deschis', d);
    P.hidden = !d;
    B.setAttribute('aria-expanded', d ? 'true' : 'false');
    if (d) setTimeout(function () { I.focus(); }, 30);
    else B.focus();
  }

  /* Rezultatele vin pe tipuri; le luăm pe rând (pagină, articol, produs),
     ca primele 5 să nu fie toate de același fel. */
  function amesteca(rez) {
    var liste = ['pages', 'articles', 'products'].map(function (k) {
      return (rez[k] || []).map(function (x) { return { fel: FEL[k], x: x }; });
    });
    var out = [];
    for (var i = 0; out.length < MAX && liste.some(function (l) { return l.length > i; }); i++) {
      liste.forEach(function (l) { if (l[i] && out.length < MAX) out.push(l[i]); });
    }
    return out;
  }

  function arata(q, rez) {
    var lista = amesteca(rez);
    if (!lista.length) {
      O.innerHTML = '<p class="cauta-gol">Nu am găsit o pagină despre asta. Încearcă alt cuvânt sau vezi <a href="' + esc(URL_BLOG) + '">ghidurile</a>.</p>';
      return;
    }
    O.innerHTML = lista.map(function (r) {
      var d = scurt(text(r.x.summary_html || r.x.body));
      return '<article><span class="cauta-fel">' + r.fel + '</span><a href="' + esc(r.x.url) + '">' + esc(r.x.title) + '</a>' +
        (d ? '<p>' + esc(d) + '</p>' : '') + '</article>';
    }).join('') + '<a class="cauta-toate" href="' + esc(URL_TOATE + '?q=' + encodeURIComponent(q)) + '">Vezi toate rezultatele</a>';
  }

  function cere(q, semnal) {
    var url = URL_SUGESTII + '?q=' + encodeURIComponent(q) +
      '&' + encodeURIComponent('resources[type]') + '=product,page,article' +
      '&' + encodeURIComponent('resources[limit]') + '=10' +
      '&' + encodeURIComponent('resources[options][fields]') + '=title,body,tag';
    return fetch(url, { signal: semnal, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) { return (j.resources && j.resources.results) || {}; });
  }

  function gol(rez) {
    return !['pages', 'articles', 'products'].some(function (k) { return rez[k] && rez[k].length; });
  }

  /* Shopify caută toate cuvintele deodată („târguri Cluj” nu găsește nimic). Fără
     rezultate, caut fiecare cuvânt separat și pun primele paginile care se potrivesc
     cu cele mai multe cuvinte. */
  function peCuvinte(q, semnal) {
    var cuvinte = q.split(/\s+/).filter(function (c) { return c.length >= MIN; });
    if (cuvinte.length < 2) return Promise.resolve({});
    return Promise.all(cuvinte.map(function (c) { return cere(c, semnal).catch(function () { return {}; }); }))
      .then(function (toate) {
        var out = {};
        ['pages', 'articles', 'products'].forEach(function (k) {
          var dupa = {}, ordine = [];
          toate.forEach(function (rez) {
            (rez[k] || []).forEach(function (x) {
              var cheie = String(x.url).split('?')[0];
              if (!dupa[cheie]) { dupa[cheie] = { x: x, n: 0 }; ordine.push(cheie); }
              dupa[cheie].n++;
            });
          });
          out[k] = ordine.map(function (c, i) { return { r: dupa[c], i: i }; })
            .sort(function (a, b) { return b.r.n - a.r.n || a.i - b.i; })
            .map(function (o) { return o.r.x; });
        });
        return out;
      });
  }

  function cauta(q) {
    q = q.trim();
    if (q.length < MIN) { ultima = ''; O.innerHTML = ''; return; }
    if (q === ultima) return;
    ultima = q;
    if (cerere) cerere.abort();
    cerere = new AbortController();
    var semnal = cerere.signal;
    cere(q, semnal)
      .then(function (rez) { return gol(rez) ? peCuvinte(q, semnal) : rez; })
      .then(function (rez) { if (q === ultima) arata(q, rez); })
      .catch(function (e) { if (e.name !== 'AbortError' && q === ultima) { ultima = ''; arata(q, {}); } });
  }

  B.addEventListener('click', function () { deschide(true); });
  R.querySelector('.cauta-inchide').addEventListener('click', function () { deschide(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !P.hidden) deschide(false);
  });
  F.addEventListener('submit', function (e) {
    e.preventDefault();
    clearTimeout(temporizator);
    cauta(I.value);
  });
  I.addEventListener('input', function () {
    clearTimeout(temporizator);
    temporizator = setTimeout(function () { cauta(I.value); }, ASTEAPTA);
  });
  R.querySelectorAll('.cauta-chips button').forEach(function (c) {
    c.addEventListener('click', function () {
      I.value = c.textContent;
      clearTimeout(temporizator);
      cauta(I.value);
    });
  });

  /* Pe telefon, pagina de produs are bara fixă de cumpărare: butonul urcă
     deasupra ei cât timp e vizibilă. Peste footer-ul închis, butonul e auriu. */
  var bare = document.querySelectorAll('[data-mcb-buybar]'),
    footer = document.querySelector('.mcb-footer');
  function pozitie() {
    var h = 0;
    bare.forEach(function (bara) { h = Math.max(h, bara.offsetHeight); });
    var jos = (window.innerWidth <= 600 ? 14 : 20) + h;
    R.style.bottom = jos + 'px';
    /* Din fereastră, nu din R: CSS-ul e neblocant, la prima rulare R nu e încă fix. */
    if (footer) R.classList.toggle('e-peste-footer', window.innerHeight - jos > footer.getBoundingClientRect().top);
  }
  addEventListener('scroll', function () { requestAnimationFrame(pozitie); }, { passive: true });
  addEventListener('resize', pozitie);
  if (window.MutationObserver) bare.forEach(function (bara) { new MutationObserver(pozitie).observe(bara, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] }); });
  pozitie();
})();
